import { Pencil01Icon, Trash01Icon } from '@langchain/untitled-ui-icons';

import { FC, useState } from 'react';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';
import { cn } from '@/utils/tailwind';

import {
  ECreateActionModalState,
  TCanvasQuickAction,
  useDeleteCanvasQuickAction,
} from '../hooks/useCanvasQuickActions';
import CustomQuickActionPopover from './CustomQuickActionPopover';

type TProps = {
  action: TCanvasQuickAction;
  onSubmit: (body: { customAction?: string }) => void;
  disabled: boolean;
};

const CustomQuickAction: FC<TProps> = ({ action, onSubmit, disabled }) => {
  const [isEditActionPopoverOpen, setIsEditActionPopoverOpen] = useState(false);

  const actionButton = (
    <button
      type="button"
      className={cn(
        'w-full flex-grow rounded-md px-1 text-left hover:bg-secondary',
        disabled && 'opacity-50'
      )}
      onClick={() => {
        onSubmit({ customAction: action.prompt });
      }}
      disabled={disabled}
    >
      <span>{action.name}</span>
    </button>
  );

  const editButton = (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        setIsEditActionPopoverOpen(true);
      }}
      className="ml-auto rounded-md p-1 hover:bg-secondary"
    >
      <Pencil01Icon className="h-4 w-4" />
    </button>
  );

  const { trigger: deleteQuickAction } = useDeleteCanvasQuickAction();
  const handleDelete = async () => {
    if (!action) return;
    await deleteQuickAction({ json: { id: action.id } });
  };

  const deleteButton = (
    <button
      type="button"
      onClick={handleDelete}
      className="ml-auto rounded-md p-1 hover:bg-secondary"
    >
      <Trash01Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className="flex w-full flex-row items-center gap-1 py-1">
      {actionButton}
      <Popover
        open={isEditActionPopoverOpen}
        onOpenChange={setIsEditActionPopoverOpen}
      >
        <PopoverTrigger>{editButton}</PopoverTrigger>
        <PopoverContent className="h-[400px] w-[400px]">
          <CustomQuickActionPopover
            onClose={() => setIsEditActionPopoverOpen(false)}
            modalState={ECreateActionModalState.EDIT}
            quickAction={action}
          />
        </PopoverContent>
      </Popover>
      {deleteButton}
    </div>
  );
};

export default CustomQuickAction;
